'use client';

import { Skeleton } from '@/components/atoms/Skeleton';
import { theme } from '@/styles/theme';

export default function FichaPaginaMobileFallback() {
  return (
    <div>
      {/* BackgroundWrapper */}
      <Skeleton style={{ height: 280, width: '100%', zIndex: -1 }} />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: theme.spacing[7],
          paddingTop: theme.spacing[5],
          paddingBottom: theme.spacing[5],
          paddingLeft: theme.spacing[4],
          paddingRight: theme.spacing[4],
        }}
      >
        {/* ContainerTop */}
        {/* <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            marginTop: '-25%',
            gap: theme.spacing[6],
            width: '100%',
            zIndex: 20,
            alignItems: 'center',
          }}
        >
          <Skeleton
            style={{
              height: theme.tamanhoCartaz.height['medio'],
              width: theme.tamanhoCartaz.width['medio'],
            }}
          />
        </div> */}

        {/* ContainerInfo */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing[4],
            maxHeight: theme.tamanhoCartaz.height['grande'],
            width: '100%',
            alignItems: 'center',
          }}
        >
          <Skeleton
            style={{
              height: theme.tamanhoCartaz.height['medio'],
              width: '100%',
            }}
          />
        </div>

        {/* Notas */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            gap: theme.spacing[5],
            width: '100%',
            justifyContent: 'space-between',
          }}
        >
          <Skeleton
            style={{
              width: '45%',
              height: 127,
            }}
          />
          <Skeleton
            style={{
              width: '45%',
              height: 127,
            }}
          />
        </div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            gap: theme.spacing[6],
          }}
        >
          {/* BlocoInformacao Sinopse */}
          <Skeleton
            style={{
              width: '100%',
              height: 344,
              borderRadius: theme.radius[2],
            }}
          />
          {/* BlocoInformacao Plataformas */}
          <Skeleton
            style={{
              width: '100%',
              height: 344,
              borderRadius: theme.radius[2],
            }}
          />
        </div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            gap: theme.spacing[6],
          }}
        >
          {/* BlocoInformacao Elenco */}
          <Skeleton
            style={{
              width: '100%',
              height: 344,
              borderRadius: theme.radius[2],
            }}
          />
          {/* BlocoInformacao Trailer */}
          <Skeleton
            style={{
              width: '100%',
              height: 344,
              borderRadius: theme.radius[2],
            }}
          />
        </div>

        {/* BlocoInformacao Críticas da comunidade */}
        <Skeleton
          style={{
            width: '100%',
            height: 870,
            borderRadius: theme.radius[2],
          }}
        />
      </div>
    </div>
  );
}
